import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "../../css/template/404.css"

export default class extends Controller {
    connect() {

    }
}